import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const ReferenceOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FormHeaderContainer = styled.div`
  display: flex;
  padding: ${token('space.300')} ${token('space.300')} ${token('space.300')};
  position: relative;
  align-items: center;
  justify-content: space-between;
`;

export const FormTitle = styled.h1`
  display: flex;
  min-width: 0;
  margin: 0;
  align-items: center;
  font: ${token('font.heading.small')};
`;
